import type { Attachment } from '~/types/blog'

// getAttachmentName 返回附件标题或地址中的文件名
export const getAttachmentName = (attachment: Attachment): string => {
  const title = attachment.title.trim()
  if (title) return title
  const name = attachment.url.split(/[?#]/)[0].split('/').pop() || '附件'
  try {
    return decodeURIComponent(name)
  } catch {
    return name
  }
}

// isImageAttachment 根据附件地址判断是否为图片
export const isImageAttachment = (attachment: Attachment): boolean =>
  /\.(png|jpe?g|gif|webp|bmp|svg|avif|heic|heif)$/i.test(attachment.url.split(/[?#]/)[0])
